import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsLeftChevronCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m3.5-11.5H7L3.5 8L7 11.5h4.5L8 8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsLeftChevronCircle
